<template>
  <megabit-base-dialog :show-dialog="showDialog">
    <template v-slot:body>
      <v-card dark>
        <v-card-title>
          {{ $t('titulos.configuracoesAcesso') }}
        </v-card-title>
        <v-card-text>
          <v-text-field
            label="URL da API"
            v-model="form.apiURL"
            :placeholder="apiURL"
            type="text"
            dark
          ></v-text-field>
          <div>
            <div class="d-flex">
              <v-btn
                color="error"
                class="mr-auto"
                @click="$emit('closeConfigDialog')"
              >
                <v-icon left>mdi-close</v-icon>
                {{ $t('labels.fechar') }}
              </v-btn>
              <v-btn color="info" class="ml-auto" @click="saveApiConfig()">
                <v-icon left>mdi-content-save</v-icon>
                {{ $t('labels.salvar') }}
              </v-btn>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </template>
  </megabit-base-dialog>
</template>

<script>
import BaseDialog from '@/components/shared/base-dialog/BaseDialog'
import { mapActions, mapState } from 'vuex'
export default {
  components: {
    'megabit-base-dialog': BaseDialog,
  },
  computed: {
    ...mapState('systemModule', ['apiURL']),
  },
  data: () => {
    return {
      form: {
        apiURL: '',
      },
    }
  },
  methods: {
    ...mapActions({
      setApiURL: 'systemModule/setApiURL',
      showLoadingDialog: 'dialogModule/setShowLoadingDialog',
      setLoadingDialogMessage: 'dialogModule/setLoadingDialogMessage',
    }),
    async saveApiConfig() {
      try {
        if (this.form.apiURL != '') {
          await this.setApiURL(this.form.apiURL)
          this.$emit('closeConfigDialog')
        } else {
          this.$toasted.error(this.$t('validation-messages.urlInvalida'))
        }
      } catch (error) {
        this.$toasted.error(error, { duration: null })
      }
    },
  },
  props: {
    showDialog: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
}
</script>

<style></style>
